import React from 'react'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Box } from '@mui/material';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1536 },
    items: 4,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 1536, min: 1024 },
    items: 3,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 640 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 640, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

interface CarouselsProps {
  children: React.ReactNode;
}

const Carousels: React.FC<CarouselsProps> = ({ children }) => {
  return (
    <div>
      <Box className="bg-gray-50">
        <Carousel
    responsive={responsive}
    infinite
    autoPlay
    autoPlaySpeed={2500}
    keyBoardControl
    showDots = {false}
    arrows = {true}
    containerClass="carousel-container"
    itemClass="px-2"
    // removeArrowOnDeviceType={false}
    renderDotsOutside
    focusOnSelect={false}
    customTransition="all 0.7s cubic-bezier(0.77, 0, 0.175, 1)"
    transitionDuration={700}
    draggable
  >
    {children}
  </Carousel>
</Box>
    </div>
  )
}

export default Carousels
